module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Tulsi Vivah")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Anna Kaling")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The festival of Tulsi Vivah ushers in the Hindu wedding season and tears away the love of Kristopher’s life. Three years of passion and tenderness are reduced to a shameful skeleton in the closet as Arjuna submits to the marriage his parents have arranged for him. His family has never even heard Kristopher’s name.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The festival, a ritualistic wedding between the holy basil plant, Tulsi, and her eternal lover, Vishnu, is as much of a play-act as Arjuna’s upcoming nuptials, but he believes the wedding will honor his parents and please Vishnu. So why is his Tulsi plant—whose leaves heal and bless the devout, who is Vishnu’s representative on earth—dying? Arjuna tends to her with all the care of a concerned parent, but it might take more than his devotion to save her. She might need Kris, with his clever green-fingers—and maybe a revived Tulsi can heal two hearts.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0